import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { AgentRoutingMethod } from './agent-routing-method.enum';
import { CallPriority } from './call-priority.enum';
import { QueuePriority } from './queue-priority.enum';
import { HoldMusicType } from './hold-music-type.enum';
import { AnnouncementLanguage } from './announcement-language.enum';
import { QueueUserDto } from './queue-user.dto';
import { DeclineReasonItemDto } from 'src/core/models/decline-reason/decline-reason-item.dto';
import { DEFAULT_SLA_TARGET_SECONDS } from './queue-sla.constant';
import { ScheduledCallOwnership } from './scheduled-call-ownership.enum';
import { DEFAULT_LAST_AGENT_DURATION_MINUTES } from './last-agent-duration.constant';
@Api('api/agentic-cx/queue')
export class QueueDto extends DtoHasApi {
  id: number | null = null;
  name = '';
  code: string | null = null;
  description: string | null = null;
  isActive = true;
  priority: QueuePriority = QueuePriority.Medium;
  agentRoutingMethod: AgentRoutingMethod = AgentRoutingMethod.LongestIdleTime;
  callPriority: CallPriority = CallPriority.Fifo;
  assignedUsers: QueueUserDto[] = [];
  wrapUpCodeIds: number[] = [];
  wrapUpCodes: { id: number; name: string }[] = [];
  maxResponseTime = 15;
  slaTargetSeconds = DEFAULT_SLA_TARGET_SECONDS;
  holdMusicType: HoldMusicType = HoldMusicType.Default;
  holdMusicFileName?: string;
  holdMusicDurationSeconds?: number;
  holdMusicSizeBytes?: number;
  announceQueuePosition = false;
  announceEstimatedWaitTime = false;
  announcementFrequencySeconds = 60;
  estimatedWaitTimeRoundToSeconds = 60;
  announcementLanguage: AnnouncementLanguage = AnnouncementLanguage.Turkish;
  declineReasonIds: number[] = [];
  declineReasons: DeclineReasonItemDto[] = [];
  scheduledCallOwnership: ScheduledCallOwnership = ScheduledCallOwnership.Queue;
  lastAgentDurationMinutes = DEFAULT_LAST_AGENT_DURATION_MINUTES;

  private _assignedAgentCount?: number;

  get assignedAgentCount(): number {
    if (this._assignedAgentCount !== undefined) {
      return this._assignedAgentCount;
    }

    return this.assignedUsers?.length ?? 0;
  }

  set assignedAgentCount(value: number) {
    this._assignedAgentCount = value;
  }
}
